export const isNumber = function(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};
export const isInteger = function(n) {
  return !isNaN(n) && 
   parseInt(Number(n)) == n && 
   !isNaN(parseInt(n, 10));
};

export const capitalize = function (value) {
  if (!value) {return '';}
  value = value.toString();

  // replace underscores with a space and capitalize the first letter after
  return value.replace(/(^|_)(\w)/g, function ($0, $1, $2) {
    return ($1 && ' ') + $2.toUpperCase();
  });
};

export const roundingMethods = [
  {value: 'nearest', label: 'to the nearest'},
  {value: 'up', label: 'up to the'},
  {value: 'down', label: 'down to the'}
];
export const precisionTypes = [
  {value: '.01', label: 'hundredths (e.g. 7777.77)'},
  {value: '.1', label: 'tenths (e.g. 7777.7)'},
  {value: '1', label: 'ones (e.g. 7777)'},
  {value: '10', label: 'tens (e.g. 7780)'},
  {value: '100', label: 'hundreds (e.g. 7800)'}
];
export const enumValidator = function (values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  }
};